document.addEventListener("DOMContentLoaded", ()=>{
    if(window.location.href.includes('collections') && window.location.href.includes("e-commerce-services-consultant")){
        if(window.location.href.includes("#quick-commerce")){
            document.documentElement.style.scrollBehavior = "smooth";
            document.getElementById("quick-commerce").style.scrollMarginTop = "200px"
        }
        localStorage.removeItem("Ecommerce-Redirection-Key")
        const anchors = document.querySelectorAll(".product--anchor");
        anchors.forEach((anchor)=>{
            anchor.addEventListener("click", (a)=>{
                a.preventDefault();
                if(localStorage.getItem("Ecommerce-Redirection-Key")){
                    localStorage.removeItem("Ecommerce-Redirection-Key")
                } else { 
                    localStorage.setItem("Ecommerce-Redirection-Key", JSON.stringify(anchor.getAttribute("href")))
                }
                window.open("https://evitamin.in/pages/ecommerce", "_self");
            })
        })
    } else if(window.location.href.includes("pages") && window.location.href.includes("ecommerce")){
        const anchors = document.querySelectorAll(".bookMeeting--anchor")
        anchors.forEach((anchor)=>{
            if(localStorage.getItem("Ecommerce-Redirection-Key")){
                const pageLink = JSON.parse(localStorage.getItem("Ecommerce-Redirection-Key"));
                anchor.href = pageLink;
                document.querySelectorAll(".slider-section--anchor.link-anchor").forEach((a)=>{
                    a.href = pageLink;
                })
            } else {
                console.error("No Redirection Key")
            }
        })
    }
})



